import { Home, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, TAGLINE, BOOKING_URL } from "@/config";

export const Footer = () => (
  <footer data-testid="site-footer" className="mt-24 bg-[#012141] text-white">
    <div className="gold-rule h-px w-full" />
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-white/8 text-[#F5C64E] ring-1 ring-[#F5C64E]/30">
            <Home size={20} fill="#F5C64E" />
          </span>
          <div className="leading-tight">
            <span className="block font-heading font-bold text-lg">{BRAND}</span>
            <span className="block text-[12px] text-white/50">{TAGLINE}</span>
          </div>
        </div>
        <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-sm">
          Un diagnostic clair en 5 minutes, des formations vivantes et une carte de protection
          personnalisée — pour prendre les bonnes décisions financières, au Québec.
        </p>
        <a href={BOOKING_URL} target="_blank" rel="noreferrer" data-testid="footer-booking-cta"
          className="btn-gold mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#C89A3E] text-[#012141] text-sm font-bold hover:brightness-105 transition-[filter]">
          <CalendarCheck size={16} /> Prendre un rendez-vous
        </a>
      </div>

      <div className="md:col-span-3 md:col-start-8">
        <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C89A3E] mb-4">Explorer</div>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/diagnostic" className="text-white/70 hover:text-[#C89A3E] transition-colors">Diagnostic 5 min</Link></li>
          <li><Link to="/formations" className="text-white/70 hover:text-[#C89A3E] transition-colors">Formations</Link></li>
          <li><Link to="/admin/login" className="text-white/70 hover:text-[#C89A3E] transition-colors">Espace conseiller</Link></li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C89A3E] mb-4">Région</div>
        <p className="text-sm text-white/70">Québec, Canada</p>
        <p className="mt-2 text-sm text-white/70">Français</p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div data-testid="footer-partner" className="max-w-7xl mx-auto px-4 sm:px-8 py-7 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.22em] text-white/40">En partenariat avec</span>
          <img src="/ia-groupe-financier.png" alt="iA Groupe financier" data-testid="footer-ia-logo" className="h-10 w-auto" />
        </div>
        <p className="text-[11px] font-bold tracking-[0.2em] text-[#C89A3E] uppercase">On s'investit, pour vous.</p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/40">© {new Date().getFullYear()} {BRAND}. Tous droits réservés.</p>
        <p className="text-xs text-white/40">Contenu à visée pédagogique — ne remplace pas un conseil personnalisé.</p>
      </div>
    </div>
  </footer>
);
